import type { AuthResponse } from '@/types/auth';
import { AuthRequestError } from './auth-errors';
import { fetchRetryingWhenBusy } from './busy-retry';

export async function registerWithInvitation(authServiceUrl: string, data: {
  token: string;
  verificationCode: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}): Promise<AuthResponse> {
  try {
    const response = await fetchRetryingWhenBusy(() => fetch(`${authServiceUrl}/auth/register-with-invitation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        invitation_token: data.token,
        verification_code: data.verificationCode,
        email: data.email,
        password: data.password,
        first_name: data.firstName,
        last_name: data.lastName,
      }),
    }));

    if (!response.ok) {
      throw await AuthRequestError.fromResponse(response);
    }

    const result = await response.json();

    return {
      success: true,
      redirect_to: result.redirect_to || result.redirect_url,
      message: result.message || 'Registration successful',
    };
  } catch (error) {
    console.error('Registration with invitation failed:', error);
    throw error;
  }
}
